import { render, staticRenderFns } from "./userCentralItem.vue?vue&type=template&id=c7c23d1e&scoped=true&"
import script from "./userCentralItem.vue?vue&type=script&lang=js&"
export * from "./userCentralItem.vue?vue&type=script&lang=js&"
import style0 from "./userCentralItem.vue?vue&type=style&index=0&id=c7c23d1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c23d1e",
  null
  
)

export default component.exports